import React from 'react';
import { SEMANTIC_HR_PAGE } from '../../../../content/enterpriseMessaging';
import ProductMediaFigure from '../../shared/ProductMediaFigure';

export default function AnalyticsAndAI() {
  const copy = SEMANTIC_HR_PAGE;
  const pillars = copy.dynamicBenefits.slice(0, 3);

  return (
    <section className="section">
      <div className="container-x">
        <div className="max-w-3xl mb-8 lg:mb-10">
          <p className="eyebrow">{copy.analyticsEyebrow}</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-ink-900">
            {copy.analyticsTitle}
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-600">{copy.analyticsIntro}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10 max-w-4xl">
          {copy.dynamicStats.map((s) => (
            <div
              key={s.value}
              className="rounded-xl border border-ink-200/80 px-5 py-4 text-center sm:text-left"
            >
              <p className="text-lg font-semibold text-brand-700">{s.value}</p>
              <p className="mt-1 text-sm text-ink-500">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mb-10 lg:mb-12">
          <ProductMediaFigure id="semantichr_clip2" aspect="natural" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl">
          {pillars.map((b) => (
            <div key={b.title} className="border-l-2 border-l-brand-200 pl-4 py-1">
              <p className="text-sm font-semibold text-ink-900">{b.title}</p>
              <p className="mt-1.5 text-sm text-ink-600 leading-relaxed">{b.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
